import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import DraggableGeomapNode from './DraggableGeomapNode';

const GeomapSelectedTabContents = ({
  activeParentNodes,
  handleNodeSelection,
  countyCategorySelectedVal,
  zipcodeCategorySelectedVal,
  selectedTab,
  geographicsData,
  toggleParentNode,
  handleDrag,
  handleDrop,
  selectedNodes,
  geographicsTableData,
  parentChildCountMap,
  isMultipleItemSelected,
  handleInvalidDrop,
}) => {
  let selectedTabVal = selectedTab;
  let listMaxheight = '';
  if (selectedTab === 'county' || selectedTab === 'zipcode') {
    selectedTabVal = selectedTabVal === 'county' ? countyCategorySelectedVal
     : zipcodeCategorySelectedVal;
    listMaxheight = 'calc(100vh - 558px)';
  } else {
    listMaxheight = 'calc(100vh - 513px)';
  }
  const renderParentNodes = tabResults => {
    return _.map(tabResults, parent => {
      const isActive = _.includes(activeParentNodes, parent.id);
      const isAlreadyDragged = _.some(geographicsTableData[selectedTab],
       el => el.id === parent.id);
      const currentlySelected = _.some(selectedNodes[selectedTab], el => el.pid === parent.pid);
      const isParentDragged = parentChildCountMap[selectedTabVal][parent.pid] === 0;
      const isSelected = (currentlySelected || isAlreadyDragged || isParentDragged);
      const selectedClass = isSelected ? 'selected' : '';
      let toggleIcon = parent.s ? String.fromCharCode(9658) : '';
      if (isActive) {
        toggleIcon = String.fromCharCode(9660);
      }
      let renderChild = '';
      if (isActive) {
        renderChild = (
          <ul>
            {
              _.map(parent.s, item => {
                const isChildActive = activeParentNodes && activeParentNodes.includes(item.id);
                const isAlreadyDragged = _.some(geographicsTableData[selectedTab],
                   el => el.id === parent.id) ||
                _.some(geographicsTableData[selectedTab],
                  el => el.id === item.id);
                const isChildParentDragged = parentChildCountMap[selectedTabVal][item.pid] === 0;
                const currentlySelected = _.some(selectedNodes[selectedTab], el => el.pid === item.pid);
                const isSelected = isAlreadyDragged || currentlySelected || isChildParentDragged;
                const childSelectedClass = isSelected ? 'selected' : '';
                let childToggleIcon = item.s ? String.fromCharCode(9658) : '';
                if (isChildActive) {
                  childToggleIcon = String.fromCharCode(9660);
                }
                let renderGrandChild = '';
                if (isChildActive) {
                  renderGrandChild = (
                    <ul>
                      {
                        _.map(item.s, subChild => {
                          const isAlreadyDragged = _.some(geographicsTableData[selectedTab],
                             el => el.id === subChild.id);
                          const currentlySelected = _.some(selectedNodes[selectedTab],
                            el => el.pid === subChild.pid);
                          const isSelected = isAlreadyDragged || currentlySelected;
                          const grandchildSelectedClass = isSelected ? 'selected' : '';
                          if (isAlreadyDragged) {
                            return (
                              <div key={subChild.id}>
                                <li>
                                  <div
                                    className="category category-question dragged-item"
                                    title={subChild.n}
                                  >
                                    <label
                                      className="node-label after-drop-label"
                                      htmlFor="childLabel"
                                    >{ subChild.n }</label>
                                    <span className="draagable-icon" />
                                  </div>
                                </li>
                              </div>
                            );
                          }
                          return (
                            <DraggableGeomapNode
                              childNode={subChild}
                              key={subChild.id}
                              handleNodeSelection={handleNodeSelection}
                              onDrop={handleDrop}
                              onDrag={handleDrag}
                              toggleIcon={childToggleIcon}
                              toggleParentNode={toggleParentNode}
                              selectedClass={grandchildSelectedClass || childSelectedClass}
                              isMultipleItemSelected={isMultipleItemSelected}
                              handleInvalidDrop={handleInvalidDrop}
                            />
                          );
                        })
                      }
                    </ul>
                  );
                }
                if (isAlreadyDragged || isChildParentDragged) {
                  return (
                    <div key={item.id}>
                      <li>
                        <div
                          className="category category-question dragged-item"
                          title={item.n}
                        >
                          {item.s &&
                          <span
                            onClick={() => toggleParentNode(item)}
                            className="toggle-icon"
                          >{ childToggleIcon }</span>}
                          <label
                            className="node-label after-drop-label"
                            htmlFor="itemLabel"
                          >{ item.n }</label>
                          <span className="draagable-icon" />
                        </div>
                      </li>
                      { renderGrandChild }
                    </div>
                  );
                }
                return (
                  <div key={item.id}>
                    <DraggableGeomapNode
                      childNode={item}
                      key={item.id}
                      handleNodeSelection={handleNodeSelection}
                      onDrop={handleDrop}
                      onDrag={handleDrag}
                      toggleIcon={childToggleIcon}
                      toggleParentNode={toggleParentNode}
                      selectedClass={childSelectedClass}
                      isMultipleItemSelected={isMultipleItemSelected}
                      handleInvalidDrop={handleInvalidDrop}
                    />
                    { renderGrandChild }
                  </div>
                );
              })
            }
          </ul>
        );
      }
      if (isAlreadyDragged || isParentDragged) {
        return (
          <div key={parent.id}>
            <li>
              <div
                className="category category-question dragged-item"
                title={parent.n}
              >
                {parent.s &&
                <span
                  onClick={() => toggleParentNode(parent)}
                  className="toggle-icon"
                >{ toggleIcon }</span>}
                <label
                  className="node-label after-drop-label"
                  htmlFor="parentLabel"
                >{ parent.n }</label>
                <span className="draagable-icon" />
              </div>
            </li>
            { renderChild }
          </div>
        );
      }
      return (
        <div id="DraggableGeomapNodeTestComp" key={parent.id}>
          <DraggableGeomapNode
            childNode={parent}
            key={parent.id}
            handleNodeSelection={handleNodeSelection}
            onDrag={handleDrag}
            toggleIcon={toggleIcon}
            onDrop={handleDrop}
            toggleParentNode={toggleParentNode}
            selectedClass={selectedClass}
            isMultipleItemSelected={isMultipleItemSelected}
            handleInvalidDrop={handleInvalidDrop}
          />
          { renderChild }
        </div>
      );
    });
  };
  return (
    <div className="row">
      {geographicsData[selectedTabVal].length > 0 &&
        <div
          className="row select-geographics-left-menu"
          style={{
            height: listMaxheight,
            width: 'auto',
            marginRight: '20px',
          }}
        >
          <div className="row select-geographics-left-menu-list">
            <ul id="renderParentNodesTestComp">
              {renderParentNodes(geographicsData[selectedTabVal])}
            </ul>
          </div>
        </div>
      }
    </div>
    );
};

GeomapSelectedTabContents.propTypes = {
  zipcodeCategorySelectedVal: PropTypes.string,
  countyCategorySelectedVal: PropTypes.string,
  selectedTab: PropTypes.string,
  geographicsData: PropTypes.shape({}),
  geographicsTableData: PropTypes.shape({}),
  parentChildCountMap: PropTypes.instanceOf(Object),
  toggleParentNode: PropTypes.func,
  activeParentNodes: PropTypes.arrayOf(PropTypes.number),
  handleNodeSelection: PropTypes.func,
  handleDrop: PropTypes.func,
  handleDrag: PropTypes.func,
  handleInvalidDrop: PropTypes.func,
  isMultipleItemSelected: PropTypes.bool,
  selectedNodes: PropTypes.shape({
    selectedTab: PropTypes.arrayOf(PropTypes.string),
  }),
};
export default GeomapSelectedTabContents;
